import * as React from 'react';
import * as Tgcc from '../../tgccGlobal';
import { ShopCartItem } from './ShopCartItem';
import { ShopCheckout } from './ShopCheckout';
import { CSSProperties } from 'react';
import { ConsoleConstructorOptions } from 'console';

const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    background: 'white',
    width: '100%'
}
const fullRowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    padding: '0 30px',
    alignItems: 'center',
}
const linkStyle: CSSProperties = {
    color: 'darkblue',
    cursor: 'pointer'
}
const listContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: '800px',
    padding: '0 30px',
    alignSelf: 'flex-start'
}
const tableStyle: React.CSSProperties = {
    display: 'flex',
    padding: '10px',
    flexDirection: 'column',
    width: '100%'
}
const cartHeaderStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 30px'
}
const titleStyle: CSSProperties = {
    display: 'flex',
    flex: '1 1 auto',
    alignSelf: 'flex-start',
    fontSize: '20px',
    fontWeight: 'bold',
}
const updateCartButtonStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end',
    backgroundColor: 'darkblue',
    color: 'white',
    lineHeight: '24px',
    padding: '5px 20px'
}
const itemsListStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'column',
    width: '100%'
}
const checkoutBoxStyle: CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-start',
    width: '450px',
    flexShrink: 1
}
const rowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    color: 'black',
    lineHeight: '24px',
    fontSize: '18px',
    alignItems: 'flex-start',
    paddingBottom: '5px',
    marginBottom: '10px',
    borderBottom: '1px solid black'
}
const headerColumnStyle: CSSProperties = {
    display: 'flex',
    flexBasis: '100%',
    flex: '1'
}
const doubleColumnStyle: CSSProperties = {
    display: 'flex',
    flexBasis: '100%',
    flex: '2'
}
type Props = {
    cart: Tgcc.WebStoreCart;
    webStore: Tgcc.WebStore;
    removeItemCallback: (id: number,size:string) => void;
    changeQuantityCallback: (id: number,size:string, qty: number) => void;
    completeCheckout: (email: string) => void;
    closeCartCallback: (evt: any) => void;
}

export class ShopCart extends React.Component<Props, any>{

    componentDidMount(){
        var tag = document.getElementById('checkoutWrapper');
        tag.scrollIntoView(false);
    }
    getCartItem = (item: Tgcc.WebStoreCartItem, ct: number) => {
        return <ShopCartItem key={'cartitem-' + ct} cartItem={item} removeCallback={this.props.removeItemCallback} changeQtyCallback={this.props.changeQuantityCallback} />
    }

    getCartItems = () => {
        var items = [];
        var ct = 0;
        if (this.props.cart && this.props.cart.items.length > 0) {
            this.props.cart.items.forEach((item: Tgcc.WebStoreCartItem) => {
                items.push(this.getCartItem(item, ct++));
            });
        }
        return items;
    }

    render() {
        return (
            <div style={wrapperStyle}>
                <div style={fullRowStyle}>
                    <a style={linkStyle} onClick={this.props.closeCartCallback}>&lt; Back</a>
                </div>
                <div style={fullRowStyle} className="checkoutRowStyle">
                    <div style={listContainerStyle} className="checkoutlistCont">
                        <div style={cartHeaderStyle}>
                            <div style={titleStyle}>Shopping Cart: </div>
                            {/* <button style={updateCartButtonStyle}>Update Cart</button> */}
                        </div>
                        <div style={itemsListStyle} id="checkoutWrapper">
                            <div style={rowStyle} className="checkoutShopHdr">
                                <div style={doubleColumnStyle}></div>
                                <div style={headerColumnStyle}>Item</div>
                                <div style={headerColumnStyle}>ItemPrice</div>
                                <div style={headerColumnStyle}>Quantity</div>
                                <div style={headerColumnStyle}>Total Price</div>
                            </div>
                            {this.getCartItems()}
                        </div>
                    </div>
                    <div style={checkoutBoxStyle}>
                        <ShopCheckout
                            cart={this.props.cart}
                            webStore={this.props.webStore}
                            completeCheckout={this.props.completeCheckout} />
                    </div>
                </div>
            </div>
        )
    }
}

